import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { JoPullBatch } from "app/model/entities/entity-model";
import { JoStatusCode } from "app/model/enums/jo-status-code";
import { DomainBaseComponent } from "app/shared/domain-base.component";
import { DomainService } from "app/shared/domain.service";
import _ from "lodash";

@Component({
  selector: "app-notepad-pull-batches",
  templateUrl: "./notepad-pull-batches.component.html",
  standalone: false,
})
export class NotepadPullBatchesComponent extends DomainBaseComponent implements OnInit {
  joPullBatches: JoPullBatch[] = [];
  searchText = "";

  constructor(
    protected domainService: DomainService,
    protected route: ActivatedRoute
  ) {
    super(domainService);
  }

  override async ngOnInit() {
    super.ngOnInit();
    const batches = await this.dbQueryService.getJoPullBatches();
    // Only show batches where every JO is still Open/Process Incomplete —
    // i.e. batches the pull screen would show as fully open. Mixed batches are
    // reachable via Change Batch. Empty batches (no JOs yet) are filtered out
    // too, since there's nothing to pull.
    const incomplete = batches.filter((b) => {
      const johs = (b.joHeaderPulls ?? []).map((jhp) => jhp.joHeader).filter((j) => !!j);
      if (johs.length === 0) return false;
      return johs.every((joh) => joh.joStatusId === JoStatusCode.OpenProcessIncomplete);
    });
    this.joPullBatches = _.orderBy(incomplete, (b) => b.id, ["desc"]);
    this.isPageReady = true;
  }

  goBack() {
    this.router.navigate(["/notepad/home"]);
  }

  openBatch(batch: JoPullBatch) {
    this.router.navigate(["/notepad/pull", batch.id]);
  }

  joCount(batch: JoPullBatch): number {
    return batch.joHeaderPulls?.length ?? 0;
  }

  accountSummary(batch: JoPullBatch): string {
    const names = _.uniq(
      (batch.joHeaderPulls ?? [])
        .map((jhp) => jhp.joHeader?.account?.accountName)
        .filter((n): n is string => !!n)
    );
    if (names.length === 0) return "—";
    if (names.length <= 2) return names.join(", ");
    return `${names.slice(0, 2).join(", ")} +${names.length - 2} more`;
  }

  get filteredBatches(): JoPullBatch[] {
    const q = this.searchText.trim().toLowerCase();
    if (!q) return this.joPullBatches;
    return this.joPullBatches.filter((b) => {
      if (String(b.id).includes(q)) return true;
      if (b.userInit?.toLowerCase().includes(q)) return true;
      const accountNames = (b.joHeaderPulls ?? [])
        .map((jhp) => jhp.joHeader?.account?.accountName?.toLowerCase() ?? "")
        .join(" ");
      return accountNames.includes(q);
    });
  }
}
